import Qrious from 'qrious'
import Config from '@/config'
import store from '@/vuex/store'

const generateQRCodePresentation = (presentation, user) => {
  let linkAudience = `${window.location.protocol}//${Config.audienceLink}/${presentation.uniqueAccessCode}`
  if (user.plan === 'white-label' && user.whiteLabelLink) {
    linkAudience = `https://${user.whiteLabelLink}/${presentation.uniqueAccessCode}`
  }
  return linkAudience
}

const setPresentationQRCode = (presentation) => {
  presentation = presentation || store.state.presentation
  const qr = new Qrious({
    value: generateQRCodePresentation(presentation, store.state.currentUser),
    size: 800,
    level: 'H',
  })

  store.state.presentation.qrcode = qr.toDataURL()
}

export default {
  generateQRCodePresentation,
  setPresentationQRCode,
}
